module.exports = __webpack_public_path__ + "img/Invite.c223bb27.svg";